import(/* webpackMode: "eager" */ "/home/jetrails/pwa.awbridal.com/html/src/app/(app)/template.jsx");
